@if (questionnaire) {
  <section
    class="c-questionnaire">
    @if (!hideAside) {
      <aside
        class="c-questionnaire-aside">
        <dl class="o-data-list c-dashboard-content__summary u-margin-bottom-none">
          @if (questionnaire.datFinalizacao; as completionDate) {
            <dt class="o-data-list__title">Finalizada em:</dt>
            <dd class="o-data-list__item">{{ completionDate }}</dd>
          }
          @if (questionnaire.nomCandidato) {
            <dt class="o-data-list__title">Participante:</dt>
            <dd class="o-data-list__item">{{ questionnaire.candidatoId }} - {{ questionnaire.nomCandidato }}</dd>
          }
          @if (questionnaire.datFinalizacao && questionnaire.qtdAcertos) {
            <dt class="o-data-list__title">Acertos:</dt>
            <dd class="o-data-list__item">
              <span class="c-pill t-alert-info u-margin-right-tiny">
                {{ questionnaire.percentual / 100 | percent:'1.0-2' }}
              </span>
              {{ questionnaire.qtdAcertos }} de
              {{ questionnaire.qtdQuestoes }} questões
            </dd>
          } @else {
            @if (!hideQuestions) {
              <dt class="o-data-list__title">Quantidade de questões: </dt>
              <dd class="o-data-list__item">{{ questionnaire.qtdQuestoes || questionnaire.questoes?.length }}</dd>
            }
          }
        </dl>
      </aside>
    }
    @if (!hideQuestions) {
      <div
        class="c-questionnaire__main">
        @if (questionnaireForm) {
          <form
            [formGroup]="questionnaireForm"
            class="o-form c-questionnaire-form">
            <ol class="c-questionnaire-questions"
              [class.o-list-bare]="hideNumbers"
              [class.o-list-ordered]="!hideNumbers"
              formArrayName="respostas">
              @for (question of questions; track question; let questionIndex = $index; let last = $last) {
                <li
                  class="c-questionnaire-questions__item"
                  [class.o-list-bare__item]="hideNumbers">
                  <p class="c-questionnaire-questions__description"
                    [innerHTML]="question.dscQuestao | safe:'html'">
                  </p>
                  @if (question) {
                    <ng-container [formGroupName]="questionIndex">
                      <mat-radio-group formControlName="alternativaId"
                        class="u-text-wrap o-form__control c-questionnaire-answers">
                        @for (answerOption of question.alternativas; track answerOption) {
                          <mat-radio-button
                            class="c-questionnaire-answer__item"
                            [class.c-questionnaire-answers__item--correct]="isAdmin && answerOption.indAlternativaCorreta"
                            [value]="answerOption.alternativaId">
                            <div [innerHTML]="answerOption.dscAlternativa | safe:'html'"></div>
                            @if (isConcluded && isAdmin) {
                              @if (answerOption.indAlternativaCorreta) {
                                <fa-icon
                                  [icon]="[ 'fas', 'check' ]"
                                  class="u-icon t-accent u-margin-left-tiny">
                                </fa-icon>
                              }
                              @if (answerOption.indAlternativaEscolhida && !correctAnswersMap.get(question.questaoId)) {
                                <fa-icon
                                  [icon]="[ 'fas', 'times' ]"
                                  class="u-icon t-alert-danger u-margin-left-tiny">
                                </fa-icon>
                              }
                            }
                          </mat-radio-button>
                        }
                      </mat-radio-group>
                      @if (isConcluded && correctAnswersMap?.get(question.questaoId) !== null) {
                        @if (correctAnswersMap?.get(question.questaoId)) {
                          <red-alert-box
                            class="t-alert-success u-margin-bottom-large"
                            [icon]="[ 'fas', 'check' ]"
                            title="Resposta correta">
                          </red-alert-box>
                        } @else {
                          <red-alert-box class="t-alert-danger u-margin-bottom-large"
                            [icon]="[ 'fas', 'times' ]"
                            title="Resposta incorreta">
                          </red-alert-box>
                        }
                      }
                    </ng-container>
                  }
                  @if (!last) {
                    <mat-divider class="c-divider"></mat-divider>
                  }
                </li>
              }
            </ol>
            @if (!isConcluded) {
              <div
                class="o-form__controls c-questionnaire-form__controls">
                <button mat-ripple
                  type="button"
                  class="c-button c-button--solid-reversed t-primary"
                  (click)="onSaveClick($event)">
                  <fa-icon class="u-margin-right-tiny"
                    [icon]="[ 'fas', 'save' ]">
                  </fa-icon>
                  Salvar
                </button>
                <button mat-ripple
                  type="button"
                  class="c-button c-button--solid t-primary"
                  [disabled]="questionnaireForm.invalid || questionnaireForm.disabled"
                  (click)="onConcludeClick($event)">
                  <fa-icon class="u-margin-right-tiny"
                    [icon]="[ 'fas', 'check' ]">
                  </fa-icon>
                  Finalizar
                </button>
              </div>
            }
          </form>
        }
      </div>
    }
  </section>
}
